var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CircularProgress, Typography, useTheme } from '@mui/material';
import { useDinPlayerContext } from 'hx-din-test-2';
import { useNavigator } from 'hx-navigator';
import { Fade, Keypad, SideImageLayout, TripletInput, useKeypad, } from 'hx-ui';
import { dinTestActions, selectActiveTestStep, } from '@/store';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useMount } from 'react-use';
import { DinTestSidePanel } from '@/components/din-test-side-panel.component';
import { StyledProgress } from '@/components/styled-progress.component';
import { useSetProgress } from 'hx-progress';
import { useIdleTimer } from 'react-idle-timer';
import { ErrorMessage } from '@/components/error-message.component';
import { NavigationButton, NavigationButtonsContainer, } from '@/components/navigation-button.component';
import { Notes } from '@/components/din-test/notes.component';
import { KeypadButton } from '@/components/din-test/keypad-button.component';
export function DinTestPage() {
    var theme = useTheme();
    var id = useParams().id;
    var dispatch = useDispatch();
    var _a = useDinPlayerContext(), playTriplet = _a.playTriplet, initialize = _a.initialize, state = _a.state, stop = _a.stop;
    var _b = useKeypad(), value = _b.value, handleChange = _b.handleChange, handleBackspace = _b.handleBackspace, isShaking = _b.isShaking, shake = _b.shake, setValue = _b.setValue, handleClear = _b.handleClear;
    var next = useNavigator({
        phaseLength: 23,
        onComplete: function () {
            dispatch(dinTestActions.processResult());
        },
    }).next;
    var activeStep = useSelector(selectActiveTestStep((id && +id - 1) || 0));
    var _c = useState(''), idleText = _c[0], setIdleText = _c[1];
    useMount(function () {
        if (!state.initialized)
            initialize();
        dispatch(dinTestActions.initializeTest());
    });
    useEffect(function () {
        dispatch(dinTestActions.setSnr(id));
    }, [id]);
    var playChallenge = useCallback(function () {
        if ((activeStep === null || activeStep === void 0 ? void 0 : activeStep.snr) === undefined)
            return;
        playTriplet(activeStep.challenge, {
            snr: activeStep.snr,
        });
    }, [activeStep]);
    useEffect(function () {
        playChallenge();
    }, [activeStep]);
    var handleSubmit = useCallback(function () {
        if (value.length < 3)
            return shake();
        var response = value;
        dispatch(dinTestActions.submitResponse({ response: response, id: id }));
        setValue([]);
        stop();
        next();
    }, [value, id]);
    useSetProgress(1, (id && +id) || 0);
    var reset = useIdleTimer({
        onIdle: function () {
            setIdleText("Enter 3 numbers, then click Submit.");
        },
        onActive: function () {
            setIdleText('');
            reset();
        },
        timeout: 1000 * 15,
        events: ['mousedown', 'keypress', 'click'],
    }).reset;
    var keys = [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'Backspace',
        '0',
        'Clear',
    ];
    if (!state.initialized)
        return (_jsx("div", __assign({ className: "grid place-items-center min-h-[31.25rem]" }, { children: _jsx(CircularProgress, {}) })));
    return (_jsx(SideImageLayout, { leftPanel: _jsx(DinTestSidePanel, {}), leftPanelWidth: "25%", header: _jsx(StyledProgress, { className: "px-4 md:px-12 py-3", textClassName: 'font-bold' }), content: _jsxs(_Fragment, { children: [_jsx(Fade, __assign({ className: "grid gap-3 px-4 py-2 place-items-center" }, { children: state.error ? (_jsx(ErrorMessage, { action: playChallenge, actionText: "Retry", message: "Oops! An error occurred while trying to play the audio" })) : (_jsxs(_Fragment, { children: [_jsxs(Typography, __assign({ className: "text-xl font-bold md:font-normal md:text-3xl text-charcoal pb-4" }, { children: ["Step ", id, " of 23"] })), _jsx(TripletInput, { className: "gap-8 flex w-full justify-center", value: value, isShaking: isShaking, digitStyle: {
                                    fontSize: '1.875rem',
                                    minHeight: '2em',
                                    borderBottomWidth: '2px',
                                    borderBottomColor: theme.palette.secondary.main,
                                    borderBottomStyle: 'solid !important',
                                    width: '50px',
                                    '&.has-value': {
                                        borderBottomColor: theme.palette.secondary.main,
                                    },
                                } }), _jsx(Keypad, { value: value, onChange: handleChange, onBackspace: handleBackspace, onSubmit: handleSubmit, buttonSize: "large", keys: keys, KeypadButton: KeypadButton, onClear: handleClear })] })) })), !!idleText && _jsx(Typography, __assign({ className: 'text-red font-extrabold text-sm' }, { children: idleText })), !idleText && _jsx(Notes, { id: id })] }), nav: _jsx(NavigationButtonsContainer, __assign({ className: 'mb-6' }, { children: _jsx(NavigationButton, { variant: "contained", label: "Submit", onClick: handleSubmit }) })) }));
}
export default DinTestPage;
